import ally from 'ally.js/ally';
import * as helpers from '../../js/helpers';

export default function toTop() {
    const btnToTop = document.querySelector('.go-to-top');
    const goToTop = document.querySelector('.js-to-top');

    if (btnToTop === null) {
        return;
    }

    const btnToTopLink = btnToTop.querySelector('a');
    const footer = document.querySelector('.footer');

    // sets the button position
    function setBtnPosition(scroll, btnHeight) {
        if (scroll) {
            btnToTop.style.position = 'fixed';
            btnToTop.style.bottom = `${btnHeight}px`;
        } else {
            btnToTop.style.position = 'relative';
            btnToTop.style.bottom = `${btnHeight / 2}px`;
        }
    }

    // smooth scroll to top
    function runScrollAnimation(scrollDuration) {
        const scrollStep = -window.pageYOffset / (scrollDuration / 10);
        const scrollInterval = setInterval(() => {
            if (window.pageYOffset !== 0) {
                window.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval);
                const body = document.body;
                if (window.responsive === 'desktop') {
                    body.setAttribute('tabindex', '0');
                    ally.element.focus(body);
                }
            }
        }, 15);
    }

    // hides the button if the scroll is at the top
    function setBtnDisplay(style) {
        if (style) {
            helpers.removeClass(btnToTop, '-is-hide');
        } else {
            helpers.addClass(btnToTop, '-is-hide');
        }
    }

    function setGoToTop() {
        const documentHeight = document.body.clientHeight;
        const scrollPosition = window.pageYOffset + window.innerHeight;
        const footerHeight = helpers.outerHeight(footer);
        const btnHeight = helpers.outerHeight(btnToTopLink);
        document.body.removeAttribute('tabindex');

        if (window.pageYOffset) {
            setBtnDisplay(true);
        } else {
            setBtnDisplay(false);
        }

        if (scrollPosition < documentHeight - (footerHeight - (btnHeight / 2))) {
            setBtnPosition(true, btnHeight);
        } else {
            setBtnPosition(false, btnHeight);
        }
    }

    if (btnToTop) {
        window.addEventListener('scroll', helpers.throttle(() => {
            setGoToTop();
        }, 250));

        window.addEventListener('resize', helpers.throttle(() => {
            setGoToTop();
        }, 250));

        btnToTop.addEventListener('click', (event) => {
            event.preventDefault();
            runScrollAnimation(500);
        });
    }

    if (goToTop) {
        goToTop.addEventListener('click', (event) => {
            event.preventDefault();
            runScrollAnimation(500);
        });
    }
}
